module.exports = __webpack_public_path__ + "static/Headspace-923d38039a1b3666f083c08cfe75bf9c.jpg";